module.exports = __webpack_public_path__ + "media/images/fullscreen/login-4bae06165fe62013818200c5e1f43056.png";